import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/core';

interface ChangeSubscriptionPayload {
  action: string;
  data: {
    plan_code: string;
    addons: any[];
    coupon_code: string;
    end_trial_period: string;
  };
  proceed_checkout?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ZohoService {
  constructor(private apiService: ApiService) {}

  verifyFeature(feature: string): Observable<any> {
    return this.apiService.get(`/api/v1/feature/verify?key=${feature}`);
  }

  changeSubscription(data: ChangeSubscriptionPayload): Observable<any> {
    return this.apiService.put('/api/v1/zoho/subscription/save/', data);
  }

  getListAddons(plan: string): Observable<any> {
    return this.apiService.get(`/api/v1/zoho/addon/list?plan_code=${plan}`);
  }

  getPlan(plan: string): Observable<any> {
    return this.apiService.get(`/api/v1/zoho/plan/list?plan_code=${plan}`);
  }

  checkActiveCards(override: boolean = false): Observable<any> {
    if (override) {
      return this.apiService.get(`/api/v1/zoho/subscription/check-active-cards?override=${override}`);
    }
    return this.apiService.get(`/api/v1/zoho/subscription/check-active-cards`);
  }

  checkIfShouldCheckZohoCard(): Observable<any> {
    return this.apiService.get(`/api/v1/zoho/subscription/check-if-should-check-card`);
  }

  getHostedPageForUnpaidInvoice(tenant_id: string): Observable<any> {
    return this.apiService.get(`/api/v1/zoho/subscription/${tenant_id}/get-hosted-page-for-unpaid-invoice`);
  }

  checkForUnpaidInvoices(tenant_id: string): Observable<any> {
    return this.apiService.get(`/api/v1/zoho/subscription/${tenant_id}/check-for-unpaid-zoho-invoices`);
  }

  makePaymentForUnpaidInvoices(tenant_id: string): Observable<any> {
    return this.apiService.post(`/api/v1/zoho/subscription/${tenant_id}/make-payment-for-zoho-unpaid-invoices/`);
  }
}
